import PropertyType from '../Modifiers/PropertyType.js';

var BlockBorderStyleOptions = /*#__PURE__*/function (BlockBorderStyleOptions) {
  BlockBorderStyleOptions["none"] = "border-style: none;";
  BlockBorderStyleOptions["solid"] = "border-style: solid;";
  BlockBorderStyleOptions["dotted"] = "border-style: dotted;";
  BlockBorderStyleOptions["dashed"] = "border-style: dashed;";
  BlockBorderStyleOptions["double"] = "border-style: double;";
  return BlockBorderStyleOptions;
}(BlockBorderStyleOptions || {});
var ThemeBlockBorderStyle = new PropertyType({
  name: 'BlockBorderStyle',
  propertyFromApi: 'block-border-style',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return BlockBorderStyleOptions[value];
  },
  defaultValue: 'none',
  options: BlockBorderStyleOptions,
  selector: '.block',
  cssVariable: '--block-border-style'
}, 'theme');
var FormBlockBorderStyle = new PropertyType({
  name: 'BlockBorderStyle',
  propertyFromApi: 'block-border-style',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return BlockBorderStyleOptions[value];
  },
  defaultValue: 'none',
  options: BlockBorderStyleOptions,
  selector: '.block',
  cssVariable: '--block-border-style'
}, 'form');

export { FormBlockBorderStyle, ThemeBlockBorderStyle };
//# sourceMappingURL=BlockBorderStyle.js.map
